"use client";

import { useOpenAccount } from "@/context/openAccount";

import LookupForm from "@/components/lookup/form";
import EmailForm from "@/components/openAccount/verify/email/form";

export default function VerifyForm() {
  const { errors, openAccountUser, setErrors, setOpenAccountUser } =
    useOpenAccount();

  if (openAccountUser?.needsSetup === false) return null;

  if (!openAccountUser?.token)
    return (
      <LookupForm
        entity={openAccountUser}
        errors={errors}
        set={setOpenAccountUser}
        setErrors={setErrors}
        title="Verify Your Account"
      />
    );
  else return <EmailForm />;
}
